import * as React from 'react';
import { memo, useCallback } from 'react';
import { Map } from 'immutable';

import Box from '../../../../components/Box';
import Label from '../../../../components/forms/Label';
import TextInput from '../../../../components/forms/TextInput';
import Text from '../../../../components/Text';

const ANSWER_MAX_LENGTH = 1000;

interface ApplicationQuestionProps {
  question: Map<string, unknown>;
  value: string;
  onChange: (key: string, value: string) => void;
}

const ApplicationQuestion = memo(
  ({ question, value, onChange }: ApplicationQuestionProps) => {
    const questionId = question.get('id') as string;
    const questionText = question.get('text') as string;

    const handleChange = useCallback(
      (val: string) => onChange(questionId, val),
      [onChange, questionId]
    );

    return (
      <Box mvm>
        <Box grow basis={200}>
          <Label>
            <Text blackLight fw400 fs16>
              {questionText}
            </Text>
          </Label>
          <Box mtxs bg="white">
            <TextInput
              type="textarea"
              name="application_answers"
              value={value}
              onChange={handleChange}
              maxLength={ANSWER_MAX_LENGTH}
              inputProps={{
                style: {
                  resize: 'none',
                },
              }}
              valueOnChange
            />
          </Box>
        </Box>
      </Box>
    );
  }
);

interface ApplicationQuestionsProps {
  questions: Map<string, unknown>[] | undefined;
  answers: Record<string, string>;
  onAnswerChange: (key: string, value: string) => void;
}

const ApplicationQuestions = memo(
  ({ questions, answers, onAnswerChange }: ApplicationQuestionsProps) => {
    if (!questions || questions.length === 0) {
      return null;
    }

    return (
      <>
        {questions.map((question: Map<string, unknown>) => (
          <ApplicationQuestion
            key={question.get('id') as React.Key}
            question={question}
            value={answers[question.get('id') as string] || ''}
            onChange={onAnswerChange}
          />
        ))}
      </>
    );
  }
);

ApplicationQuestion.displayName = 'ApplicationQuestion';
ApplicationQuestions.displayName = 'ApplicationQuestions';

export default ApplicationQuestions;
